import { render } from "./InviteFriendsModal.vue?vue&type=template&id=132d6353&scoped=true&ts=true"
import script from "./InviteFriendsModal.vue?vue&type=script&lang=ts"
export * from "./InviteFriendsModal.vue?vue&type=script&lang=ts"

import "./InviteFriendsModal.vue?vue&type=style&index=0&id=132d6353&scoped=true&lang=css"

import exportComponent from "/home/bese/Documents/partybeast/party-beast-prototype/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132d6353"]])

export default __exports__